import { ANIMATION_TYPES } from '@website-editor/context/NavigationPaneContext/NavigationPane.constants';
import { CUSTOM_PAGE_ACTIONS } from '@website-editor/customComponents/CustomComponents.constants';

export enum VIDEO_ACTIONS {
  VIDEO_ADD = 'video_add',
  VIDEO_EDIT = 'video_edit',
}

export const VIDEO_SCREENS = [VIDEO_ACTIONS.VIDEO_ADD, VIDEO_ACTIONS.VIDEO_EDIT];

export const VIDEO_ANIMATION_CONFIG = {
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS]: [
    {
      navigatedFrom: VIDEO_ACTIONS.VIDEO_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: VIDEO_ACTIONS.VIDEO_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD]: [
    {
      navigatedFrom: VIDEO_ACTIONS.VIDEO_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: VIDEO_ACTIONS.VIDEO_EDIT,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [VIDEO_ACTIONS.VIDEO_ADD]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS_ADD,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
  [VIDEO_ACTIONS.VIDEO_EDIT]: [
    {
      navigatedFrom: CUSTOM_PAGE_ACTIONS.CUSTOM_COMPONENTS,
      animationType: ANIMATION_TYPES.OVERLAY_VIEW,
    },
  ],
};
